import templateStr from 'text!./cp-building-input-directive.html';
import _ from 'lodash';
import PropertyCodeUtil from 'edge/quoteandbind/common/util/PropertyCodeUtil';
import PropertyCodeViewDirective from 'edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode';
import ViewModelUtil from 'gw-portals-viewmodel-js/ViewModelUtil';

export default [function () {
    return {
        restrict: 'AE',
        template: templateStr,
        scope: {
            buildingView: '=',
            classCode: '=',
            address: '=',
            jobId: '@',
            sessionId: '@',
            readonly: '='
        },
        controller: ['$scope', 'qnb.PropertyCodeLookupService', 'ModalService', function ($scope, PropertyCodeLookupService, ModalService) {

            var lookupCodesPromise = PropertyCodeLookupService.getPropertyCodes('CommercialProperty', $scope.jobId, $scope.classCode || null, $scope.address, $scope.sessionId);

            $scope.classcodeLookup = {
                getMatches: function getMatches(userinput) {
                    return lookupCodesPromise.then(function (propertyCodes) {
                        return _(propertyCodes).filter(function (code) {
                            return PropertyCodeUtil.toString(code).toLowerCase().includes((userinput || '').toLowerCase());
                        }).take(10).valueOf();
                    }).catch(function () {
                        return ModalService.showError('quoteandbind.cp.controllers.CPBuildingCtrl.There was an error retrieving property class code', 'quoteandbind.cp.controllers.CPBuildingCtrl.Please check for errors and try again');
                    });
                },
                toString: function toString(code) {
                    if (ViewModelUtil.isViewModelNode(code)) {
                        return code.value;
                    }

                    return PropertyCodeUtil.toString(code);
                },
                directive: PropertyCodeViewDirective
            };

            var anAlarmTypeIsDefined = !!$scope.buildingView.alarmType;

            $scope.hasAlarm = { // A fake viewmodel node to render a yes-no group
                value: anAlarmTypeIsDefined,
                aspects: {
                    required: false,
                    inputCtrlType: 'boolean',
                    get valid() {
                        return true;
                    }
                }
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/directives/cp-building-input-directive/CPBuildingInputDirective.js
// module id = 994
// module chunks = 0